var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotRewardsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 81,
    viewBox: "0 0 132 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 81,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "My Certificate"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2892_239)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -28,
    y: -183.953,
    width: 360,
    height: 800,
    rx: 12,
    fill: "#021239"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 10960"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12,
    y: -11.9531,
    width: 156,
    height: 156,
    rx: 16,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: -11.5,
    y: -11.4531,
    width: 155,
    height: 155,
    rx: 15.5,
    stroke: "url(#paint0_linear_2892_239)",
    strokeOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1973353393"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 10957",
    y: 0.046875,
    width: 132,
    height: 80,
    rx: 12,
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    filter: "url(#filter0_d_2892_239)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M66.2905 50.7442L68.4522 36.4397L65.2583 35.9566L63.2969 48.9478L63.2945 48.9475C63.2945 48.9475 63.2907 48.9735 63.2876 49.0117L63.1267 50.0699C62.7842 51.913 61.8126 55.345 59.3415 54.9717L68.4842 56.3525C66.0935 55.9908 66.0935 52.6494 66.2928 50.7446L66.2905 50.7442Z",
    fill: "url(#paint1_linear_2892_239)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M55.1367 19.525C55.7894 20.0012 56.3506 20.609 56.7869 21.3122C57.8923 23.1265 57.8486 25.206 56.6571 26.8775C56.1937 27.5418 55.526 27.9832 54.7637 28.1453C54.4205 28.2307 54.0515 28.2447 53.6762 28.2022C52.4348 28.0558 51.2967 27.2483 50.8561 26.1921C50.4909 25.2989 50.6347 24.342 51.2613 23.5517C51.6751 23.03 52.4264 22.9435 52.9485 23.3549C53.4638 23.7629 53.5567 24.52 53.1453 25.0421C53.0416 25.1743 53.057 25.2176 53.0755 25.2734C53.1696 25.4899 53.5423 25.7661 53.9463 25.8103C54.379 25.8562 54.5819 25.6394 54.6996 25.4779C54.7202 25.4519 54.7382 25.4279 54.7521 25.3986C55.4475 24.3673 55.1663 23.3776 54.8511 22.7717C54.8087 22.698 54.7707 22.6273 54.7293 22.5633C53.9335 21.2599 52.3473 20.4622 50.9635 20.6645C49.3671 20.901 48.1141 22.4308 47.4507 24.9708C46.1676 29.8666 49.1773 33.7633 51.0887 35.6463C53.1674 37.6913 55.3494 38.9087 56.8659 39.4548C57.7342 39.7765 58.3787 39.8773 58.6677 39.7986C59.3091 39.6213 59.9685 40.0019 60.1393 40.6376C60.2523 41.0234 60.1564 41.4175 59.9263 41.7051C59.7725 41.9001 59.5623 42.0506 59.3071 42.1126C59.0146 42.198 58.675 42.226 58.3158 42.2052C55.9403 42.121 52.2305 40.153 49.4021 37.3522C45.4703 33.4712 43.9527 28.8593 45.1247 24.3627C46.3772 19.5953 49.102 18.5038 50.6085 18.288C52.1673 18.0605 53.8246 18.5353 55.1343 19.5246L55.1367 19.525Z",
    fill: "url(#paint2_linear_2892_239)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M82.3903 23.4624C81.6203 23.7103 80.898 24.1124 80.2656 24.6435C78.6483 26.0214 78.0386 28.0091 78.6446 29.9706C78.8773 30.7455 79.3726 31.3752 80.0447 31.7673C80.3433 31.9555 80.689 32.0854 81.0592 32.1633C82.2854 32.4138 83.6177 32.0013 84.3684 31.1373C84.9939 30.4049 85.1566 29.4507 84.809 28.5022C84.5811 27.8776 83.8908 27.56 83.2686 27.7884C82.6514 28.015 82.3264 28.7066 82.5548 29.3288C82.6115 29.4868 82.582 29.5235 82.5488 29.5694C82.3926 29.7471 81.9517 29.8907 81.5535 29.8063C81.1273 29.7155 81.0023 29.4462 80.9409 29.2538C80.9308 29.2234 80.9184 29.1926 80.9157 29.1608C80.5779 27.9626 81.1529 27.1118 81.6446 26.6351C81.7086 26.5768 81.7649 26.5222 81.8248 26.4754C82.9874 25.4854 84.744 25.2262 85.9957 25.8498C87.4382 26.5735 88.1503 28.42 87.9847 31.0396C87.671 36.093 83.5914 38.8492 81.1879 40.038C78.5741 41.3291 76.1203 41.8009 74.5081 41.8469C73.5812 41.8788 72.9375 41.7733 72.6908 41.6095C72.1382 41.242 71.3918 41.3943 71.0317 41.9456C70.8025 42.2769 70.7729 42.6806 70.8988 43.0272C70.9834 43.2592 71.1367 43.4673 71.36 43.6084C71.6103 43.78 71.9243 43.9125 72.2727 44.0065C74.5543 44.671 78.6961 43.9639 82.2568 42.1874C87.2074 39.734 90.0898 35.8286 90.3867 31.1904C90.6884 26.2705 88.4448 24.3802 87.0799 23.704C85.6705 23.002 83.9495 22.9332 82.3953 23.4607L82.3903 23.4624Z",
    fill: "url(#paint3_linear_2892_239)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M81.227 21.5301C81.227 21.5301 81.1098 22.387 80.8325 23.7808C79.7416 29.2984 76.1425 43.2927 67.4059 46.1476L66.9596 46.4281C66.3969 46.7785 65.7147 46.904 65.0632 46.7852L64.661 46.7123C64.0895 46.6076 63.5735 46.3202 63.1809 45.8987L62.7704 45.4503C55.3621 40.2051 55.9506 26.0777 56.5322 20.3269C56.6905 18.7878 56.8417 17.8465 56.8417 17.8465C57.0476 16.4785 58.7042 16.3594 58.7042 16.3594L79.8735 19.5614C79.8735 19.5614 81.4305 20.1617 81.2246 21.5297L81.227 21.5301Z",
    fill: "url(#paint4_linear_2892_239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M79.7101 23.1674L57.7983 19.8575C56.4563 19.6554 55.5267 18.3929 55.7288 17.0509C55.9309 15.709 57.1934 14.7793 58.5353 14.9814L80.4471 18.2913C81.7891 18.4934 82.7187 19.7559 82.5166 21.0979C82.3145 22.4398 81.052 23.3695 79.7101 23.1674Z",
    fill: "url(#paint5_linear_2892_239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M79.7101 23.1674L57.7983 19.8575C56.4563 19.6554 55.5267 18.3929 55.7288 17.0509C55.9309 15.709 57.1934 14.7793 58.5353 14.9814L80.4471 18.2913C81.7891 18.4934 82.7187 19.7559 82.5166 21.0979C82.3145 22.4398 81.052 23.3695 79.7101 23.1674Z",
    fill: "url(#paint6_linear_2892_239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M79.7101 23.1674L57.7983 19.8575C56.4563 19.6554 55.5267 18.3929 55.7288 17.0509C55.9309 15.709 57.1934 14.7793 58.5353 14.9814L80.4471 18.2913C81.7891 18.4934 82.7187 19.7559 82.5166 21.0979C82.3145 22.4398 81.052 23.3695 79.7101 23.1674Z",
    fill: "url(#paint7_linear_2892_239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M55.0755 55.5964L72.3777 58.2108C73.2447 58.3418 73.8423 59.1522 73.7113 60.0192L72.3052 69.3247L51.8634 66.2359L53.2695 56.9304C53.4005 56.0634 54.2108 55.4657 55.0778 55.5968L55.0755 55.5964Z",
    fill: "url(#paint8_linear_2892_239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M73.6873 67.7559L50.9941 64.3269C50.8558 64.306 50.7267 64.4012 50.7058 64.5395L50.5173 65.7868C50.4964 65.9251 50.5916 66.0542 50.7299 66.0751L73.4231 69.5041C73.5614 69.525 73.6905 69.4298 73.7114 69.2915L73.8998 68.0441C73.9207 67.9058 73.8256 67.7768 73.6873 67.7559Z",
    fill: "url(#paint9_linear_2892_239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M73.6873 67.7559L50.9941 64.3269C50.8558 64.306 50.7267 64.4012 50.7058 64.5395L50.5173 65.7868C50.4964 65.9251 50.5916 66.0542 50.7299 66.0751L73.4231 69.5041C73.5614 69.525 73.6905 69.4298 73.7114 69.2915L73.8998 68.0441C73.9207 67.9058 73.8256 67.7768 73.6873 67.7559Z",
    fill: "url(#paint10_linear_2892_239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M69.0069 60.1064L57.7265 58.4019C57.3142 58.3396 56.9295 58.6233 56.8672 59.0356L56.3039 62.7634C56.2416 63.1757 56.5253 63.5605 56.9376 63.6228L68.2181 65.3273C68.6304 65.3896 69.0151 65.1058 69.0774 64.6935L69.6407 60.9657C69.703 60.5534 69.4192 60.1687 69.0069 60.1064Z",
    fill: "url(#paint11_linear_2892_239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M68.8427 56.4088L58.975 54.9178C58.8758 54.9028 58.7833 54.971 58.7683 55.0702L58.6333 55.9632C58.6184 56.0623 58.6866 56.1548 58.7858 56.1698L68.6535 57.6609C68.7527 57.6758 68.8452 57.6076 68.8602 57.5084L68.9951 56.6155C69.0101 56.5163 68.9419 56.4238 68.8427 56.4088Z",
    fill: "url(#paint12_linear_2892_239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M68.8427 56.4088L58.975 54.9178C58.8758 54.9028 58.7833 54.971 58.7683 55.0702L58.6333 55.9632C58.6184 56.0623 58.6866 56.1548 58.7858 56.1698L68.6535 57.6609C68.7527 57.6758 68.8452 57.6076 68.8602 57.5084L68.9951 56.6155C69.0101 56.5163 68.9419 56.4238 68.8427 56.4088Z",
    fill: "url(#paint13_linear_2892_239)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 11044",
    opacity: 0.2,
    filter: "url(#filter1_f_2892_239)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 60.0469,
    width: 44,
    height: 5,
    rx: 2.5,
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    opacity: 0.1,
    d: "M117.342 19.2178C110.444 19.9241 109.873 20.4951 109.171 27.3887C108.465 20.4913 107.894 19.9203 101 19.2178C107.897 18.5115 108.468 17.9405 109.171 11.0469C109.877 17.9443 110.448 18.5153 117.342 19.2178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    opacity: 0.22,
    d: "M38 17.5469C33.3572 18.0223 32.9729 18.4066 32.5 23.0469C32.0246 18.4041 31.6402 18.0197 27 17.5469C31.6428 17.0715 32.0271 16.6871 32.5 12.0469C32.9754 16.6896 33.3598 17.074 38 17.5469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    opacity: 0.11,
    d: "M107.106 63.0997C102.842 63.5355 102.489 63.8886 102.053 68.1525C101.617 63.8886 101.264 63.5355 97 63.0997C101.264 62.6639 101.617 62.3108 102.053 58.0469C102.489 62.3108 102.842 62.6639 107.106 63.0997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    opacity: 0.11,
    d: "M25.1057 63.0997C20.8417 63.5355 20.4886 63.8886 20.0528 68.1525C19.617 63.8886 19.2639 63.5355 15 63.0997C19.2639 62.6639 19.617 62.3108 20.0528 58.0469C20.4886 62.3108 20.8417 62.6639 25.1057 63.0997Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2892_239",
    x: 41.473,
    y: 13.3202,
    width: 52.2074,
    height: 61.0863,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.63291
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.63291
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2892_239"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2892_239",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2892_239",
    x: 35,
    y: 51.0469,
    width: 62,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "effect1_foregroundBlur_2892_239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2892_239",
    x1: 66,
    y1: -11.9531,
    x2: 66,
    y2: 144.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2892_239",
    x1: 66.4766,
    y1: 38.0105,
    x2: 63.7712,
    y2: 56.6405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2892_239",
    x1: 54.3519,
    y1: 20.7742,
    x2: 51.2215,
    y2: 42.3307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2892_239",
    x1: 82.3649,
    y1: 24.8864,
    x2: 79.2719,
    y2: 46.1862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2892_239",
    x1: 68.8998,
    y1: 20.6189,
    x2: 64.8942,
    y2: 48.2023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2892_239",
    x1: 69.4189,
    y1: 17.0433,
    x2: 68.725,
    y2: 21.8216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2892_239",
    x1: 69.4189,
    y1: 17.0433,
    x2: 68.725,
    y2: 21.8216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2892_239",
    x1: 69.4189,
    y1: 17.0433,
    x2: 68.725,
    y2: 21.8216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2892_239",
    x1: 63.5739,
    y1: 57.9284,
    x2: 62.0051,
    y2: 68.3112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2892_239",
    x1: 62.3169,
    y1: 66.2062,
    x2: 62.0647,
    y2: 67.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2892_239",
    x1: 62.3169,
    y1: 66.2062,
    x2: 62.0647,
    y2: 67.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2892_239",
    x1: 63.293,
    y1: 59.746,
    x2: 62.5399,
    y2: 64.7299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2892_239",
    x1: 63.8915,
    y1: 55.7813,
    x2: 63.7109,
    y2: 56.9765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515D7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2892_239",
    x1: 63.8915,
    y1: 55.7813,
    x2: 63.7109,
    y2: 56.9765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8C3E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#515D7D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2892_239"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -28,
    y: -183.953,
    width: 360,
    height: 800,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotRewardsIcon);
export default __webpack_public_path__ + "static/media/SpotRewardsIcon.355e14057d164d89972ac8134d47921b.svg";
export { ForwardRef as ReactComponent };